export const SET_SYMPLAEVENTS = 'SYMPLA/SET_SYMPLAEVENTS'
export const SET_SYMPLAEVENT = 'SYMPLA/SET_SYMPLAEVENT'
export const SET_SYMPLATICKETS = 'SYMPLA/SET_SYMPLATICKETS'
export const SET_SYMPLATICKET = 'SYMPLA/SET_SYMPLATICKET'
